import { IProfileHelp } from "~/common/types-and-interfaces";

export const PROFILE_HELP: IProfileHelp = {
  headerTitle: "ПН-НД",
  headerSubtitle: "24 год/добу",
  title: "Часті питання",
  arrayItems: [
    {
      id: 1,
      title: "Як знайти лікаря для заключення декларації?",
      description: [
        "На головній сторінці beHeals перейдіть за посиланням “Декларація з лікарем” або в пошуку лікарів застосуйте фільтр “Лікар приймає декларації”.",
        "Після його застосування система покаже які є лікарі, у вашому населеному пункті, з вільними місцями на заключення декларації.",
        " Разом з цим, у лікарів первинної ланки (терапевтів, сімейних лікарів, педіатрів) – є відповідна відмітка у профілі “Лікар приймає декларації”, якщо готовий заключати декларації.",
      ],
    },
    {
      id: 2,
      title: "Як переукласти декларацію з новим лікарем?",
      description: [
        "Для цього потрібно звернутись до нового лікаря, якого ви обрали (попередньо перевіривши чи має він місця для заключення декларацій) та підписати нову декларацію.",
        "Попередня декларація розривається автоматично. Процедура зміни лікарів безкоштовна. Кількість перепідписання декларацій необмежена.",
      ],
    },
    {
      id: 3,
      title: "За яких причин мені можуть відмовити у заключенні декларації?",
      description: [
        "Якщо у лікаря набраний ліміт – лікар може вам відмовити у заключенні з ним декларації. Інших причин відмови, як “не ваша дільниця”, “у вас інша прописка” — не існує. Це питання регулюється ст. 9 Закону України «Про державні фінансові гарантії медичного обслуговування населення».",
        `Перевірити чинний ліміт декларацій на сайті НСЗУ “Електронна карта місць надання первинної медичної допомоги” та зліва ввівши прізвище, ім’я та по батькові обраного вами лікаря.`,
        " На період дії воєнного стану електронні дашборди відключені, тому рекомендуємо телефонувати в НСЗУ за номером 16-77.",
      ],
    },
    {
      id: 4,
      title: "Як відбувається процес заключення декларації?",
      description: [
        "Перед тим як йти до лікаря чи реєстратури на підписання декларації – ми радимо максимально заповнити всі дані в особистому профілі на beHealse.",
        "Лікар або уповноважений працівник медичного закладу (працівник реєстратури, медсестра):",
        "• вносить дані пацієнтів в Електронну систему охорони здоров'я;",
        "• реєструє декларацію в системі, після чого на мобільний телефон пацієнта надійде СМС з кодом підтвердження, який пацієнт має повідомити працівнику закладу;",
        "• роздруковує з електронної системи дві копії декларації, які пацієнту необхідно підписати після перевірки на правильність внесених даних;",
        "• одну з копій пацієнт забирає з собою, інша — залишається у закладі.",
      ],
    },
    {
      id: 5,
      title: "Чи можна заключити декларацію онлайн?",
      description: [
        "На жаль, поки що заключити декларацію онлайн неможливо, адже такий процес не затверджено законодавчо і поки що в процесі розробки з боку центральної бази даних (ЕСОЗ).",
      ],
    },
    {
      id: 6,
      title: "Що потрібно мати при собі для заключення декларації з лікарем?",
      description: [
        "1. Документ, що посвідчує особу (оригінал або електронна версія у Дії), це може бути один із перелічених документів: ",
        "• паспорт громадянина України;",
        "• тимчасове посвідчення громадянина України;",
        "• свідоцтво про народження (якщо декларація укладається з дитиною);",
        "• посвідка на постійне проживання в Україні (для іноземців);",
        "• посвідчення біженця;",
        "• посвідчення особи, яка потребує додаткового захисту.",
        "2. РНОКПП (раніше - ІПН);",
        "3. Мобільний телефон.",
      ],
    },
  ],
};
